import * as yup from 'yup';

export const addProductSchema = yup.object({
  quote: yup.string().required('Quote is required'),
  variant: yup.string().required('Choose a variant'),
});

export const addQuoteSetSchema = yup.object({
  property: yup
    .object()
    .shape({
      id: yup
        .string()
        .required('Property ID is required') // Ensure `id` is a required non-empty string
        .test('id-check', 'Invalid property ID', function (value) {
          return value && value.trim() !== ''; // Reject empty string
        }),
      name: yup
        .string()
        .required('Property name is required') // Ensure `name` is a required non-empty string
        .test('name-check', 'Invalid property name', function (value) {
          return value && value.trim() !== ''; // Reject empty string
        }),
      etag: yup.string().nullable(), // Other fields are optional or nullable
      createdOn: yup.date().nullable(),
      lastModified: yup.date().nullable(),
      propertyStatus: yup.string().nullable(),
      annotation: yup.string().nullable(),
    })
    .required('Please select a property') // Ensure the entire `property` object is required
    .test('property-check', 'Please select a property', function (value) {
      // Ensure both `id` and `name` are present and valid
      const hasValidProperty = value && value.id && value.name;
      return hasValidProperty;
    }),
});

export const addQuoteSchema = yup.object({
  name: yup.string().required('Quote name is required'),
});

export const editQuoteSchema = yup.object({
  name: yup.string().required('Quote name is required'),
});

export const generateQuoteSchema = yup.object({
  sales_method: yup.string().required('Sale Method is required'),
  vendor_name: yup.string().required('Vendor Name is required'),
});

export const saveQuoteSchema = yup.object({
  name: yup.string().optional(),
});

export const loadQuoteSchema = yup.object({
  quote: yup.string().required('Quote is required'),
});

export const sendPurchaseOrderSchema = yup.object({
  subject: yup.string().required('Subject is required'),
  body: yup.string().required('Description is required'),
  to: yup
    .array()
    .test('valid-email-check', 'Each recipient must be a valid email address', (value) => {
      // Check that every email in the array is valid
      if (!value) return false;
      for (const email of value) {
        if (!yup.string().email().isValidSync(email)) {
          return false;
        }
      }
      return true;
    })
    .test('min-check', 'At least one recipient is required', (value) => {
      return value && value.length > 0;
    })
    .required('Recipient is required'),
  cc: yup
    .array()
    .test('valid-email-check', 'Each recipient must be a valid email address', (value) => {
      if (!value) return true; // Optional field
      for (const email of value) {
        if (!yup.string().email().isValidSync(email)) {
          return false;
        }
      }
      return true;
    })
    .optional(),
  bcc: yup
    .array()
    .test('valid-email-check', 'Each recipient must be a valid email address', (value) => {
      if (!value) return true; // Optional field
      for (const email of value) {
        if (!yup.string().email().isValidSync(email)) {
          return false;
        }
      }
      return true;
    })
    .optional(),
  reply_to: yup
    .array()
    .test('valid-email-check', 'Each recipient must be a valid email address', (value) => {
      if (!value) return false;
      for (const email of value) {
        if (!yup.string().email().isValidSync(email)) {
          return false;
        }
      }
      return true;
    })
    .test('min-check', 'At least one recipient is required', (value) => {
      return value && value.length > 0;
    })
    .required('Recipient is required'),
});
